import React, { Component } from 'react'
import LineGraph from './LineChart.js'
import SeriesButton from '../Report/Controls/SeriesButton';
import {sensorTypeName} from '../Report/Measure/Sensors.js'

import './UsageChart.css'

export default class UsageChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConsumption: true,
      showUsage: true,
    }
    this.toggleConsumption = this.toggleConsumption.bind(this);
    this.toggleUsage = this.toggleUsage.bind(this);
  }
  toggleConsumption() {
    this.setState({showConsumption: !this.state.showConsumption})
  }
  toggleUsage() {
    this.setState({showUsage: !this.state.showUsage})
  }
  hasData () {
    const ndata = this.props.data.map(item => isNaN(item))
    const result = ndata.reduce((result, item) => result && item, true)
    return !result
  }
  render() {
    if (!this.hasData())
      return null;
    let thruProps = {...this.props}
    thruProps.data = this.state.showUsage ? thruProps?.data : null;
    thruProps.series2 = this.state.showConsumption ? thruProps?.series2 : null
    const cp = this.props?.chartProps
    const units = cp['units'+this.props.seq] ?? "Units Not Available"
    const sensor = sensorTypeName(cp['SensorType'+this.props.seq] ?? "Sensor unavailable")
    const type = cp?.Type ?? "MDT"
    return (
      <>
        <div className='chart-topper'>
          <span className='ct-info'>{type}&nbsp;{this.props.deviceId}</span>
          <span className='ct-data'>Showing: {units} for {sensor}</span>
          <SeriesButton on={this.state.showConsumption} onClick={this.toggleConsumption} color='rgba(0, 192, 166, 0.5)'/>
          <span className="btnlabel">Consumption</span>
          <SeriesButton on={this.state.showUsage} onClick={this.toggleUsage} color='#007ac0' />
          <span className="btnlabel">Use</span>
          </div>
        <LineGraph {...thruProps}/>
      </>
    )
  }
}